import { ref } from 'vue'

const getProductMovementSsq = (loc_id, date_span, sale_days_diff) => {

    const ssq_result = ref([])
    const ssq_error = ref(null)

    let url = process.env.VUE_APP_STORE_URL

    const ssq_load = async () => {
        try {

            const data = {
                "params": {
                    "date_span": date_span,
                    "sale_days_diff": sale_days_diff
                }
            }

            let res = await fetch(url + 'api/v2/movements/' + loc_id, {
                                    method: "POST",
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'api_token': localStorage.getItem('api_token'),
                                        'Origin': '*'
                                    },
                                    body: JSON.stringify(data),
                                    redirect: 'follow'
                                })

            let return_result = await res.json()
            const r = return_result.result

            if (r.success) {

                ssq_result.value = r

            } else {

                ssq_error.value = r.message

            }
        }
        catch (err) {
            ssq_error.value = err.message
        }
    }

    return {
        ssq_result, ssq_error, ssq_load
    }

}

export default getProductMovementSsq